/** @format */

import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  userIdFilter: "",
  userNameFilter: "",
  departmentIdFilter: "",
  departmentNameFilter: "",
  masterProcessIdFilter: "",
  masterProcessNameFilter: "",
  processIdFilter: "",
  processNameFilter: "",
  processListIdFilter: "",
  processListNameFilter: "",
};

const CommonFiltersSlice = createSlice({
  name: "commonFilters",
  initialState,
  reducers: {
    setUserIdFilter(state, action) {
      state.userIdFilter = action.payload;
    },
    setUserNameFilter(state, action) {
      state.userNameFilter = action.payload;
    },
    resetUserFilter(state) {
      state.userIdFilter = "";
      state.userNameFilter = "";
    },
    setDepartmentIdFilter(state, action) {
      state.departmentIdFilter = action.payload;
    },
    setDepartmentNameFilter(state, action) {
      state.departmentNameFilter = action.payload;
    },
    resetDepartmentFilter(state) {
      state.departmentIdFilter = "";
      state.departmentNameFilter = "";
    },
    setMasterProcessIdFilter(state, action) {
      state.masterProcessIdFilter = action.payload;
    },
    setMasterProcessNameFilter(state, action) {
      state.masterProcessNameFilter = action.payload;
    },
    resetMasterProcessFilter(state) {
      state.masterProcessIdFilter = "";
      state.masterProcessNameFilter = "";
    },
    setProcessIdFilter(state, action) {
      state.processIdFilter = action.payload;
    },
    setProcessNameFilter(state, action) {
      state.processNameFilter = action.payload;
    },
    resetProcessFilter(state) {
      state.processIdFilter = "";
      state.processNameFilter = "";
    },
    setProcessListIdFilter(state, action) {
      state.processListIdFilter = action.payload;
    },
    setProcessListNameFilter(state, action) {
      state.processListNameFilter = action.payload;
    },
    resetProcessListFilter(state) {
      state.processListIdFilter = "";
      state.processListNameFilter = "";
    },
  },
});

export const {
  setUserIdFilter,
  setUserNameFilter,
  resetUserFilter,
  setDepartmentIdFilter,
  setMasterProcessIdFilter,
  setMasterProcessNameFilter,
  resetMasterProcessFilter,
  setProcessIdFilter,
  setProcessNameFilter,
  resetProcessFilter,
  setDepartmentNameFilter,
  resetDepartmentFilter,
  setProcessListIdFilter,
  setProcessListNameFilter,
  resetProcessListFilter,
} = CommonFiltersSlice.actions;

export default CommonFiltersSlice.reducer;
